import { AccountData } from "@/entities/accounts/types";
import { UserData } from "@/entities/users/types";
import { createContext } from "react";

interface AnalyticsContextProps {
  track: (event: string, properties?: Record<string, any>) => void;
  identify: (user: UserData, account: AccountData) => void;
}

export const AnalyticsContext = createContext<
  AnalyticsContextProps | undefined
>(undefined);
